import React from "react";

/**
 * PONPISH 서비스 이용약관 (React + TailwindCSS 단일 파일)
 * - 기본 Tailwind 설정(설치/빌드)은 프로젝트에 이미 구성되어 있다고 가정합니다.
 * - 본 컴포넌트는 단독 페이지로 사용하거나, 라우터에 연결해 사용 가능합니다.
 * - 좌측 고정 목차 + 우측 본문 레이아웃(>=lg) / 모바일에서는 상단 드롭다운 목차 제공.
 */

const sections = [
  {
    id: "purpose",
    title: "제1조(목적)",
    body: (
      <p>
        본 약관은 주식회사 챙기고(이하 “회사”라 함)가 개발, 소유하는 콘택트렌즈 플랫폼(이하
        “플랫폼”이라 함)에서 제공하는 온라인 예약 신청 서비스(이하 “서비스”라 한다)를
        이용함에 있어 “회사”와 “회원”의 권리 · 의무 및 책임사항을 규정함을 목적으로 합니다.
      </p>
    ),
  },
  {
    id: "definitions",
    title: "제2조(용어의 정의)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>
          “플랫폼”이라 함은 제휴 안경원이 콘택트렌즈 및 관련 상품 정보를 고객에게 제공하고,
          고객의 상품 예약 요청 및 제휴 안경원의 판단과 재량에 따른 고객과의 거래 조율 등,
          제휴 안경원의 업무를 보조하기 위해 회사가 개발 및 운영하는 정보 모듈을 말합니다.
        </li>
        <li>
          “회원”이라 함은 카카오계정 등 어느 하나의 계정인증을 통해 회원가입을 하여 플랫폼을
          이용할 수 있는 권한을 부여받은 자를 말합니다.
        </li>
        <li>
          “멤버십 포인트 회원”이라 함은 “공식 사이트(ponpish.co.kr)”에서 “멤버십 포인트 이용약관”에
          동의하여 신규회원으로 등록하는 경우 또는 기존회원이 “공식 사이트(membership.ponpish.kr)”
          또는 제휴 안경원에서 “멤버십 포인트 이용약관”에 동의하여 정상적으로 멤버십 포인트를
          이용할 수 있는 권한을 부여 받은 자를 말합니다.
        </li>
        <li>
          “제휴 안경원”이라 함은 회사로부터 콘택트렌즈 및 관련 상품(이하, “상품”이라 함)을 공급받아
          고객에게 판매하는 오프라인 매장을 말합니다.
        </li>
        <li>
          “서비스”라 함은 회사가 보유한 플랫폼을 통해 제휴 안경원의 고객들과의 거래 업무를 보조하기 위해
          활용되는 예약 모듈 등을 말합니다.
        </li>
        <li>
          “멤버십 포인트”라 함은 “회원”이 ‘제휴 안경원’에서 상품을 구매하거나 “회사”에서 주최하는 이벤트,
          추가 적립 서비스 등 마케팅 활동 등과 관련하여 획득한 환가 불가능한 “회사” 전용의 비재산적 데이터를 말합니다.
        </li>
        <li>본 약관에서 정의되지 않은 용어는 관련법령이 정하는 바에 따릅니다.</li>
      </ol>
    ),
  },
  {
    id: "tos-change",
    title: "제3조(약관 등의 명시와 설명 및 개정)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>
          “회사”는 본 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자 불만 처리 주소 포함),
          연락처, 사업자등록번호, 통신판매업 신고번호, 개인정보관리책임자 등을 회원이 쉽게 알 수 있도록
          “플랫폼” 초기 화면에 게시합니다. 단, 약관의 내용은 연결 화면으로 열람 가능하도록 할 수 있습니다.
        </li>
        <li>
          “회사”가 약관을 개정할 경우, 적용일자 및 개정사유를 명시하여 현행 약관과 함께 적용일자 7일 전부터
          적용 전일까지 공지합니다. 회원에게 불리한 변경은 최소 30일 이상 사전 고지합니다.
        </li>
        <li>
          개정 약관은 적용일자 이후 제공되는 서비스에만 적용되며, 그 이전에 이미 제공된 서비스에는 개정 전 약관이 적용됩니다.
          다만, 종전 서비스에 대해서도 회원이 개정 약관 적용을 요청하고 회사가 동의한 경우에는 개정 약관을 적용합니다.
        </li>
        <li>회원은 변경된 약관에 동의하지 않을 권리가 있으며, 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.</li>
      </ol>
    ),
  },
  {
    id: "service-scope",
    title: "제4조(서비스의 제공 및 변경)",
    body: (
      <>
        <p className="mb-3">“플랫폼”은 다음과 같은 업무를 수행합니다.</p>
        <ol className="list-decimal pl-5 space-y-2">
          <li>상품 정보 제공</li>
          <li>제휴 안경원 고객 거래 보조를 위한 예약 서비스 제공</li>
          <li>기타 회사가 정하는 서비스 또는 업무</li>
        </ol>
        <p className="mt-3">
          회사는 상품 품절 등으로 서비스 내용을 변경할 경우 그 사유를 플랫폼 및 파트너 센터에 신속히 공지합니다.
        </p>
      </>
    ),
  },
  {
    id: "suspend",
    title: "제5조(서비스의 중단)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>플랫폼 설비 장애 또는 이용 폭주로 이용 지장이 있는 경우</li>
        <li>전기통신사업법에 따른 기간통신사업자 서비스 중지 등 통신 두절</li>
        <li>국가 비상상태</li>
      </ol>
    ),
  },
  {
    id: "join",
    title: "제6조(회원 및 제휴 안경원 가입)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 회사가 정한 양식에 따라 정보 기입 후 약관 동의로 가입을 신청합니다.</li>
        <li>
          회사는 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.
          <ol className="list-decimal pl-5 mt-2 space-y-1">
            <li>과거 제7조 제3항에 따라 자격 상실 후 3년 경과 및 재가입 승낙 없는 경우</li>
            <li>등록 내용 허위·누락·오기가 있는 경우</li>
          </ol>
        </li>
        <li>회원은 등록 사항 변경 시 지체 없이 회원정보 수정 등으로 변경 사실을 알려야 합니다.</li>
        <li>만 14세 미만 아동의 회원 가입은 제한됩니다.</li>
        <li>제휴 안경원은 회사가 정한 양식에 따라 가입을 신청하며, 허위·오기가 없는 경우 등록됩니다.</li>
      </ol>
    ),
  },
  {
    id: "leave",
    title: "제7조(회원탈퇴 및 자격상실 등)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 처리합니다.</li>
        <li>
          다음 각 호에 해당하는 경우 회사는 회원 자격을 제한·정지할 수 있습니다.
          <ol className="list-decimal pl-5 mt-2 space-y-1">
            <li>가입 시 허위 내용 등록</li>
            <li>다른 회원의 플랫폼 이용 방해</li>
            <li>법령 또는 본 약관 위반</li>
          </ol>
        </li>
        <li>제한·정지 후 동일 행위 반복 또는 30일 내 미시정 시 자격 상실 처리할 수 있습니다.</li>
        <li>자격 상실 시 회원등록을 말소하며, 최소 30일의 소명 기회를 부여합니다.</li>
      </ol>
    ),
  },
  {
    id: "notice",
    title: "제8조(회원 및 제휴 안경원에 대한 통지)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원 통지는 플랫폼 게시를 원칙으로 하되 중대한 사항은 개별 통지합니다.</li>
        <li>제휴 안경원 통지는 파트너 센터 공지사항 게시로 갈음합니다.</li>
      </ol>
    ),
  },
  {
    id: "apply",
    title: "제9조(서비스 신청)",
    body: (
      <>
        <p className="mb-3">회원은 플랫폼에서 다음과 유사한 방법으로 서비스를 신청합니다.</p>
        <ol className="list-decimal pl-5 space-y-2">
          <li>제휴 안경원에서 구매할 상품 선택</li>
          <li>신청자명 및 연락처 입력</li>
          <li>거래 희망 제휴 안경원 선택</li>
          <li>서비스 취소 관련 내용 확인</li>
          <li>약관 동의 표시</li>
          <li>서비스 신청 및 확인</li>
        </ol>
        <p className="mt-3">
          회사가 제휴 안경원에 신청자 개인정보를 제공하는 경우, 실제 신청 시 신청자의 동의를 받아야 하며 제공 항목, 목적,
          보유·이용 기간 등을 명시합니다.
        </p>
      </>
    ),
  },
  {
    id: "establish",
    title: "제10조(서비스의 성립)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>
          제휴 안경원이 회사로부터 회원의 신청을 통보받은 경우 수락 여부를 결정하며,
          수락과 동시에 서비스가 개시되고 회원에게 수신 확인을 통지합니다. 단, 신청 및 수락 자체로 법적 구속력은 없습니다.
        </li>
        <li>수락 의사표시에는 신청 확인, 정정·취소 등 정보가 포함되어야 합니다.</li>
      </ol>
    ),
  },
  {
    id: "cancel",
    title: "제11조(서비스 신청 취소)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사가 제휴 안경원에 상품을 공급하기 전까지 신청을 취소할 수 있습니다.</li>
        <li>회원의 취소 요청이 있는 경우 회사는 지체 없이 제휴 안경원에 통보합니다.</li>
        <li>미성년자는 법정대리인 동의가 없으면 본인 또는 법정대리인이 신청을 취소할 수 있습니다.</li>
      </ol>
    ),
  },
  {
    id: "supply",
    title: "제12조(상품의 공급 및 회수, 환불)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스 개시일로부터 3영업일 이내에 회사는 상품을 제휴 안경원에 공급합니다.</li>
        <li>회원 및 제휴 안경원이 진행 사항을 확인할 수 있도록 적절한 조치를 합니다.</li>
        <li>상품 도착 후 30일 내 회원이 미수령 시 제휴 안경원은 회수를 요청할 수 있으며 회사는 이에 따릅니다.</li>
        <li>회원은 제휴 안경원에서 수령한 상품을 단순 변심 사유 및 구매일 기준 7일 이후에는 환불할 수 없습니다.</li>
        <li>상품이 불량인 경우에 한해 회원은 회사에 환불 또는 교환을 요청할 수 있습니다.</li>
        <li>환불 또는 회수 완료 후 회사는 회원이 사용한 결제수단으로 대금을 환급합니다.</li>
      </ol>
    ),
  },
  {
    id: "payment",
    title: "제13조(지급방법)",
    body: (
      <>
        <p className="mb-3">
          회원은 회사의 서비스를 통해 제휴 안경원에 상품 구매를 신청하고 선결제함으로써 상품을 수령합니다. 가용한 지급 방법은 다음과 같습니다.
        </p>
        <ol className="list-decimal pl-5 space-y-2">
          <li>계좌이체(폰뱅킹, 인터넷뱅킹, 메일뱅킹 등)</li>
          <li>선불/직불/신용카드 결제</li>
          <li>온라인 무통장입금</li>
          <li>전자화폐 결제</li>
          <li>기타 전자적 지급 방법</li>
        </ol>
        <p className="mt-3">회사는 상품 공급 금액 외 명목의 수수료를 추가 징수하지 않습니다.</p>
      </>
    ),
  },
  {
    id: "point-earn",
    title: "제14조(멤버십 포인트 적립)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>제휴 안경원 구매, 회사 이벤트, 추가 적립 서비스 등으로 적립됩니다.</li>
        <li>
          회사 정책에 따라 일부 상품은 적립 제한·적립률 조정이 가능하며 “공지 사이트(membership.ponpish.kr)”에 고지됩니다.
        </li>
        <li>멤버십 포인트는 공지 사이트에서 조회 가능합니다.</li>
        <li>포인트 사용 구매분에 대해 추가 적립은 불가합니다.</li>
        <li>부정 적립 시 회사는 즉시 차감·삭제할 수 있습니다.</li>
      </ol>
    ),
  },
  {
    id: "point-use",
    title: "제15조(멤버십 포인트 사용)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회원은 제휴 안경원에서 포인트로 상품을 구매할 수 있습니다.</li>
        <li>사용 시 제휴 안경원은 본인 확인을 위한 정보를 요청할 수 있습니다.</li>
        <li>포인트 사용 구매 취소/환불 시 사용분은 포인트로만 환불됩니다.</li>
        <li>타인 포인트의 부정 사용은 금지되며, 신고 접수 시 즉시 조치합니다.</li>
        <li>포인트는 본인만 사용 가능하며 타인에게 양도·대여·담보 제공할 수 없습니다.</li>
        <li>본인 과실로 타인 사용 시 책임은 회원에게 있습니다.</li>
      </ol>
    ),
  },
  {
    id: "point-fix",
    title: "제16조(멤버십 포인트 정정 및 양도)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>
          적립 오류 시 오류 발생 시점부터 30일 이내 정정 신청할 수 있으며, 회사는 요청일로부터 30일 이내 조정할 수 있습니다.
          필요한 경우 영수증 등 객관적 자료를 제시해야 합니다.
        </li>
        <li>
          추후 매출 취소 등 발생 시 해당 적립은 자동 차감되며, 잔여 포인트가 부족하면 마이너스로 관리 후 차기 적립과 상계됩니다.
        </li>
      </ol>
    ),
  },
  {
    id: "point-manage",
    title: "제17조(멤버십 포인트 관리)",
    body: (
      <p>
        회원 정보 변경 발생 시 지체 없이 회사에 통지하여야 하며, 미이행으로 인한 사후 포인트 이전 등 문제 발생 시 책임은 회원에게 있습니다.
      </p>
    ),
  },
  {
    id: "point-expire",
    title: "제18조(멤버십 포인트 소멸)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>
          포인트 유효기간은 공식 사이트(ponpish.co.kr/membership)에서 확인 가능하며, 기간 경과 시 자동 소멸됩니다.
        </li>
        <li>유효기간 경과 포인트는 사용 및 환불이 불가합니다.</li>
        <li>회원 탈퇴 시 미사용 포인트는 탈퇴 처리 완료일에 자동 소멸되며, 재가입해도 복구되지 않습니다.</li>
        <li>자격 상실 통보를 받은 경우 포인트는 즉시 소멸합니다.</li>
      </ol>
    ),
  },
  {
    id: "point-end",
    title: "제19조(멤버십 포인트 서비스 종료)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스 종료 3개월 전 공지 사이트에 공지합니다.</li>
        <li>
          종료일 이후 적립·사용이 불가하며, 통지 시점 기적립 포인트는 회사가 지정하는 날까지 지정 방식에 따라 사용해야 하며 미사용 잔여분은 소멸됩니다.
        </li>
      </ol>
    ),
  },
  {
    id: "privacy",
    title: "제20조(개인정보보호)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>원활한 서비스 제공을 위해 필요한 최소한의 정보만 수집합니다.</li>
        <li>개인식별이 가능한 정보 수집 시 반드시 회원 동의를 받습니다.</li>
        <li>관련 법령·국가기관 요청을 제외하고 회원 동의 없이 제3자에 제공하지 않습니다.</li>
        <li>회원은 개인정보 열람·정정·동의 철회를 요구할 수 있으며 회사는 지체 없이 조치합니다.</li>
        <li>기타 사항은 별도 개인정보처리방침에 따릅니다.</li>
      </ol>
    ),
  },
  {
    id: "company-duty",
    title: "제21조(“회사“의 의무)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>법령 및 약관을 준수하고 지속·안정적으로 서비스를 제공합니다.</li>
        <li>회원의 개인정보 보호를 위한 보안 체계를 갖춥니다.</li>
        <li>부당한 표시·광고로 손해 발생 시 배상 책임을 집니다.</li>
        <li>회원이 원하지 않는 영리 목적 광고성 이메일을 발송하지 않습니다.</li>
      </ol>
    ),
  },
  {
    id: "account-duty",
    title: "제22조(회원의 ID 및 비밀번호에 대한 의무)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>ID와 비밀번호 관리 책임은 회원에게 있습니다.</li>
        <li>제3자에게 ID·비밀번호를 이용하게 해서는 안 됩니다.</li>
        <li>도난·무단 사용 인지 시 즉시 회사에 통보하고 안내에 따라야 합니다.</li>
      </ol>
    ),
  },
  {
    id: "member-duty",
    title: "제23조(회원의 의무)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>서비스 신청 시 허위 내용 등록 금지</li>
        <li>타인의 개인정보 도용 금지</li>
        <li>플랫폼 게시 정보 무단 변경 금지</li>
        <li>회사 미승인 정보(프로그램 등) 송신·게시 금지</li>
        <li>회사 및 제3자의 지식재산권 침해 금지</li>
        <li>회사 및 제3자의 명예 훼손·업무 방해 행위 금지</li>
        <li>공서양속에 반하는 정보 공개·게시 금지</li>
      </ol>
    ),
  },
  {
    id: "copyright",
    title: "제24조(저작권의 귀속 및 이용제한)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사가 작성한 저작물의 저작권 등 지식재산권은 회사에 귀속됩니다.</li>
        <li>
          회원은 회사에 지식재산권이 귀속된 정보를 사전 승낙 없이 복제·송신·출판·배포·방송 기타 방법으로 영리 이용하거나
          제3자에게 이용하게 할 수 없습니다.
        </li>
        <li>회사와 약정에 따라 회원에게 귀속된 저작권 사용 시 당해 회원에게 통보합니다.</li>
      </ol>
    ),
  },
  {
    id: "posts",
    title: "제25조(게시물)",
    body: (
      <>
        <ol className="list-decimal pl-5 space-y-2">
          <li>회원이 플랫폼에 게시한 게시물의 권리는 회원에게 있습니다.</li>
          <li>
            회사는 필요 시 사전 통지 없이 편집·이동할 수 있으며, 다음의 경우 삭제할 수 있습니다.
            <ol className="list-decimal pl-5 mt-2 space-y-1">
              <li>음란·선정적 내용</li>
              <li>공공질서·미풍양속 위반</li>
              <li>타인 비방·명예 훼손</li>
              <li>영리 목적 광고</li>
              <li>범죄적 행위 결부</li>
              <li>제3자 권리 침해</li>
              <li>저작권·명예훼손 등 이의 제기된 경우</li>
              <li>이용 목적 및 취지와 무관한 내용</li>
              <li>기타 약관 또는 법령 위반</li>
            </ol>
          </li>
          <li>게시물 내용으로 발생하는 결과의 책임은 회원에게 있습니다.</li>
          <li>회원 탈퇴 후 기존 게시물(댓글 포함)은 삭제되지 않습니다. 삭제를 원할 경우 탈퇴 전 직접 삭제해야 합니다.</li>
        </ol>
      </>
    ),
  },
  {
    id: "dispute",
    title: "제26조(분쟁해결)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>회사는 정당한 의견·불만 처리를 위한 인력 및 설비를 운영합니다.</li>
        <li>신속한 처리가 곤란한 경우 사유와 처리 일정을 통보합니다.</li>
      </ol>
    ),
  },
  {
    id: "jurisdiction",
    title: "제27조(재판관할 및 준거법)",
    body: (
      <ol className="list-decimal pl-5 space-y-2">
        <li>분쟁 관련 소송의 관할은 민사소송법에 따릅니다.</li>
        <li>제기된 소송에는 대한민국법을 적용합니다.</li>
      </ol>
    ),
  },
  {
    id: "kakao",
    title: "제28조(카카오톡 알림톡 시행에 관한 내용)",
    body: (
      <>
        <p>
          회사는 서비스 진행 내역 등 비광고성 정보를 카카오톡 알림톡으로 안내할 수 있습니다. 이동통신망 이용 시 데이터 요금이
          발생할 수 있으며, 수신을 원치 않을 경우 알림톡을 차단해 주시기 바랍니다.
        </p>
        <div className="mt-4 rounded-xl border p-4 bg-gray-50">
          <strong className="block mb-2">&lt;주의사항&gt;</strong>
          <ul className="list-disc pl-5 space-y-2">
            <li>콘택트렌즈를 처음 사용하는 회원은 사용·관리 방법을 충분히 숙지 후 예약 신청해야 합니다.</li>
            <li>
              올바르지 못한 렌즈 착용은 각종 안질환의 원인이 될 수 있으며, 착용으로 인한 부작용 및 질환에 대해서는 책임지지 않습니다.
            </li>
            <li>
              착용이 서투르거나 올바르지 않은 착용으로 이상 증세가 있을 경우 안과 진단 후 구매해야 합니다.
            </li>
            <li>
              온라인에서는 서비스 신청만 가능하며, 제휴 안경원 방문 시 상담 및 안내를 통해 안전하게 상품을 전달합니다.
            </li>
            <li>도수 체크가 필요한 경우 사전 검안 후 서비스를 신청해 주시기 바랍니다.</li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: "effective",
    title: "시행일",
    body: <p>본 약관은 2025년 8월 20일부터 시행하며 종전의 약관은 본 약관으로 대체합니다.</p>,
  },
];

function Toc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <nav className="hidden lg:block sticky top-24 h-[calc(100vh-6rem)] overflow-auto pr-6">
      <h2 className="text-sm font-semibold text-black mb-3">목차</h2>
      <ol className="space-y-2 text-sm">
        {sections.map((s) => (
          <li key={s.id}>
            <a
              href={`#${s.id}`}
              className="block rounded-md px-2 py-1 hover:bg-gray-100 transition text-black"
            >
              {s.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

function MobileToc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <details className="lg:hidden mb-4 rounded-xl border bg-white shadow-sm">
      <summary className="cursor-pointer select-none px-4 py-3 text-sm font-medium text-black">목차 열기</summary>
      <div className="border-t px-4 py-3">
        <ol className="space-y-2 text-sm">
          {sections.map((s) => (
            <li key={s.id}>
              <a href={`#${s.id}`} className="block rounded-md px-2 py-1 hover:bg-gray-100 text-black">
                {s.title}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </details>
  );
}

export default function PONPISHTermsPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* 컨테이너 */}
      <main className="mx-auto max-w-6xl px-2 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-8">
          <Toc sections={sections.map(({ id, title }) => ({ id, title }))} />

          <article className="min-w-0">
            <div className="rounded-2xl border bg-white p-6">
              <h1 className="text-2xl font-bold tracking-tight text-black">[PONPISH] 서비스 이용약관</h1>
              <p className="mt-2 mb-4 text-sm text-gray-600">시행일: 2025년 8월 1일</p>

              <MobileToc sections={sections.map(({ id, title }) => ({ id, title }))} />

              <div className="divide-y">
                {sections.map((s) => (
                  <section id={s.id} key={s.id} className="scroll-mt-24 py-6">
                    <h2 className="text-lg font-semibold mb-3 text-black">{s.title}</h2>
                    <div className="space-y-3 leading-7 text-black">{s.body}</div>
                  </section>
                ))}
              </div>

              <footer className="mt-6 border-t pt-4 text-xs text-gray-600">
                본 문서는 정보 제공 목적으로 안내되며, 실제 운영 정책·법령 변경 등에 따라 갱신될 수 있습니다.
              </footer>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
}
